<template>
	<div class="last">
		<div class="container">
			<span>2013-2019 {{siteName}} 版权所有 |<a href="http://beian.miit.gov.cn"> {{icp}} </a> </span>
       		 
		</div>
		
	</div>
</template>

<script>
	export default{
		nameL:"",
		components:{},
		data(){
			return{
				msg:'last',
				siteName:'天图智能',
				icp:'粤ICP备13017220号-4',
			}
		},
		methods:{
			getInfo(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getInfoApi,
					data: {}
				})
				.then((res) => {
					this.icp = res.data.data.icp;
					this.siteName = res.data.data.siteName;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getInfo();
		}
	}
</script>

<style lang="less" scoped="scoped">
.last{
	width: 100%;
	height: 50px;
	background: #999;
	text-align: center;
	line-height: 50px;
	font-size: 16px;
	color: #000;
	margin-bottom: -200px;
	a{
		color: #000;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/common/Last.vue